/* 🤖 this file was generated by svg-to-ts */
export const matIconCurrencyBitcoin: {
  name: 'currency-bitcoin';
  data: string;
} = {
  name: 'currency-bitcoin',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17.06 11.57c.59-.69.94-1.59.94-2.57 0-1.86-1.27-3.43-3-3.87V3h-2v2h-2V3H9v2H6v2h2v10H6v2h3v2h2v-2h2v2h2v-2c2.21 0 4-1.79 4-4 0-1.45-.78-2.73-1.94-3.43zM10 7h4c1.1 0 2 .9 2 2s-.9 2-2 2h-4V7zm5 10h-5v-4h5c1.1 0 2 .9 2 2s-.9 2-2 2z"/></svg>`
};
